import type {
  InvoiceEmailListQueryParams,
  InvoiceEmailListResponse,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  zodInvoiceEmailListQueryParamsSchema,
  zodInvoiceEmailListResponseSchema,
} from './validations';

/**
 * Fetches invoice inbox emails visible to the current user.
 *
 * @param queryParams - Search, filter, sort, and pagination parameters.
 * @param options - Request options supplied by TanStack Query.
 * @returns A validated paginated invoice email response.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoice-Emails/operation/list_invoice_emails_invoice_emails_get
 */
export async function fetchInvoiceEmails(
  queryParams: Partial<InvoiceEmailListQueryParams>,
  options?: KyRequestOptions,
) {
  return vestigasApi
    .get(ENDPOINT.INVOICE_EMAIL.GET_ALL(), {
      ...options,
      searchParams: withoutObjectKeysWhereValueIs(queryParams, [
        null,
        undefined,
      ]) as Record<string, string | number | boolean | undefined>,
      validate: {
        searchParams: zodInvoiceEmailListQueryParamsSchema,
        response: zodInvoiceEmailListResponseSchema,
      },
    })
    .json<InvoiceEmailListResponse>();
}
